import React, { useEffect, createElement } from 'react';
import { Helmet } from 'react-helmet-async';
import { Button } from '../shared/Button';
import { ArrowLeftIcon } from 'lucide-react';
export const BookingPage = () => {
  useEffect(() => {
    // Load the HubSpot Meetings embed script
    const script = document.createElement('script');
    script.src = 'https://static.hsappstatic.net/MeetingsEmbed/ex/MeetingsEmbedCode.js';
    script.async = true;
    document.body.appendChild(script);
    return () => {
      document.body.removeChild(script);
    };
  }, []);
  return <div className="w-full min-h-screen bg-gradient-to-b from-[#231232] to-[#1a0d24] flex flex-col" data-id="element-23" data-mp="1sd0two9qlkqa">
      <Helmet data-id="element-24" data-mp="1ehgiedwc84sw">
        <title data-id="element-25" data-mp="1jeff947dypus">Schedule Your Consultation | ApplyPass Platinum</title>
        <meta name="description" content="Schedule a consultation with our career transformation experts" data-id="element-26" data-mp="1jep4uqoiquzy" />
      </Helmet>
      {/* Header */}
      <header className="w-full py-6 px-4 sm:px-6 lg:px-8 border-b border-[#6805DA]/20" data-id="element-27" data-mp="3drewt2vbtu4p">
        <div className="max-w-7xl mx-auto flex justify-between items-center" data-id="element-28" data-mp="2yfvvrxisjxlj">
          <Button variant="ghost" href="/" q className="text-white/80 hover:text-white flex items-center gap-2" data-id="element-29" data-mp="2thucpcld7ya2">
            <ArrowLeftIcon size={18} data-id="element-30" data-mp="37b3fuvipznk5" />
            <span data-id="element-31" data-mp="336voeqkvnti8">Back to Home</span>
          </Button>
        </div>
      </header>
      {/* Main Content */}
      <main className="flex-1 py-12 px-4 sm:px-6 lg:px-8 flex flex-col items-center" data-id="element-32" data-mp="2fh1cqccaoazk">
        <div className="max-w-4xl w-full mx-auto text-center mb-10" data-id="element-33" data-mp="2aizxk2hzovtd">
          <h1 className="text-3xl sm:text-4xl font-outfit font-bold mb-6 text-white" data-id="element-34" data-mp="2akt0b6phevw3">
            Schedule Your Consultation
          </h1>
          <div className="h-1 w-24 bg-gradient-to-r from-[#FFC501] to-[#DF4425] mx-auto rounded-full mb-6" data-id="element-35" data-mp="2jj52m5zpni4d"></div>
          <p className="text-lg text-white/80 max-w-2xl mx-auto" data-id="element-36" data-mp="3r8v4pc1qwdj">
            Select a time that works for you to speak with our Head of Product and Operations, Beatrice, and explore how we can help you land your
            dream role.
          </p>
        </div>
        {/* HubSpot Meetings Embed */}
        <div className="w-full max-w-4xl bg-white/5 backdrop-blur-sm p-6 sm:p-8 rounded-2xl shadow-xl border border-white/10" data-id="element-37" data-mp="2xj70yt2jfcrn">
          <div className="meetings-iframe-container" data-src="https://meetings.hubspot.com/applypass-beatrice/platinum?embed=true" data-id="element-38" data-mp="31mmw1kyyl528"></div>
          <div className="mt-8 text-center" data-id="element-39" data-mp="29vyysk0eojtu">
            <p className="text-white/60 text-sm" data-id="element-40" data-mp="29suqbafwr1xd">
              Having trouble with scheduling? Contact us at{' '}
              <a href="mailto:support@applypass.com" className="text-[#FFC501] hover:underline" data-id="element-41" data-mp="2ivm075t4xpmw">
                support@applypass.com
              </a>
            </p>
          </div>
        </div>
      </main>
    </div>;
};